const ko = {
    nav: {
      home: "홈",
      browse: "웨딩 찾기",
      dashboard: "대시보드",
      messages: "메시지",
      profile: "프로필",
      login: "로그인",
      register: "회원가입",
      logout: "로그아웃",
      admin: "관리자",
      faq: "FAQ",
      about: "소개",
      contact: "문의",
      pricing: "요금",
      howItWorks: "이용 방법",
    },
    auth: {
      login: {
        title: "다시 오신 것을 환영합니다",
        email: "이메일",
        password: "비밀번호",
        button: "로그인",
        noAccount: "계정이 없으신가요?",
        register: "지금 가입하세요",
      },
      register: {
        title: "계정 만들기",
        name: "이름",
        email: "이메일",
        password: "비밀번호",
        role: "원하는 것...",
        roleHost: "웨딩 주최하기",
        roleGuest: "웨딩 참석하기",
        terms: "이용약관 및 개인정보처리방침에 동의합니다",
        button: "가입하기",
        hasAccount: "이미 계정이 있으신가요?",
        login: "로그인하세요",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "로딩 중...",
      error: "오류가 발생했습니다",
      success: "성공",
      save: "저장",
      cancel: "취소",
      delete: "삭제",
      edit: "수정",
      back: "뒤로",
      next: "다음",
      language: "언어",
      currency: "통화",
      search: "검색",
      filter: "필터",
      all: "전체",
      none: "없음",
      yes: "예",
      no: "아니오",
    },
    footer: {
      about: "소개",
      privacy: "개인정보처리방침",
      terms: "이용약관",
      contact: "문의",
      copyright: "© 2024 WEDVAYA. All rights reserved.",
    },
  };

export default ko;
